import React from 'react';
import About from '../About/About';
import Footer from '../Footer/Footer';
import MenuBar from '../MenuBar/MenuBar';

const AboutUs = () => {
    return (
        <div>
            <MenuBar></MenuBar>
            <About></About>
            <Footer></Footer>
        </div>
    );
};

export default AboutUs;